
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke-width":"5","stroke-linecap":"round","stroke-linejoin":"round","stroke":"#ffb0e2"}},[_c('path',{attrs:{"d":"M4 4h16c1.102 0 2 .898 2 2v12c0 1.102-.898 2-2 2H4c-1.102 0-2-.898-2-2V6c0-1.102.898-2 2-2zm0 0","stroke-width":"1.1881"}}),_c('path',{attrs:{"d":"M22 6l-10 7L2 6","stroke-width":"1.1881"}})])])
          )
        }
      }
    